<script lang="ts" setup>
  defineProps<{
    showStep?: boolean;
  }>();

  const steps = ['Entrega', 'Pagamento'];
  const currentStep = inject<number>('currentStep', 0);
</script>

<template>
  <div class="store-checkout-header">
    <div class="checkout-header-content">
      <SolLink id="brand" @click="navigateTo('/')">
        <img src="/icons/brand-loja.svg" alt="brand" />
      </SolLink>
      <HeaderCheckoutSteps
        v-if="showStep"
        :steps="steps"
        :current="currentStep"
        class="steps" />
    </div>
  </div>
  <SolDivider thickness="x-small" />
</template>

<style lang="scss">
  @mixin site-container {
    @apply w-full md:site:max-w-[1440px];
    @apply md:site:mx-auto;
  }

  .store-checkout-header {
    @apply flex flex-col;
    @apply px-2xs py-3xs;

    > .checkout-header-content {
      @apply flex flex-col md:site:flex-row items-center md:site:justify-between gap-micro;
      @include site-container;

      > img {
        @apply w-[100px] relative top-2;
      }

      > .steps {
        @apply w-64;
      }
    }
  }
</style>
